import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ProgramService } from '../../../../services/program.service';
import { NotificationsService } from 'angular2-notifications';
import { StorageUtil } from '../../../../store';

@Component({
  selector: 'app-tryout-program-create',
  templateUrl: './tryout-program-create.component.html',
  styleUrls: ['./tryout-program-create.component.css']
})
export class TryoutProgramCreateComponent implements OnInit {
  public dateValue: Date = new Date();
  public minDate: Date = new Date();
  public program_name = '';
  public clubAddForm: FormGroup;
  public programStatusValue: string;
  public allowParentToEditQuestion: string;
  public isArchive: string;
  public alphaDashSpaceRegex: RegExp;
  public isSaving = false;
  public validationMessages = {};
  public pageHeaderName: string;

  constructor(
    private notificationsService: NotificationsService,
    private fb: FormBuilder,
    private programService: ProgramService,
    private router: Router) {

    this.alphaDashSpaceRegex = /^[a-z0-9_ \-]+$/i;
    this.isArchive = '0';
    this.programStatusValue = '1';
    this.allowParentToEditQuestion = '0';

    this.validationMessages = {
      'ProgramNameRequired': 'Please enter program name.',
      'RegistrationOpenDateRequired': 'Please select registration open date.',
      'RegistrationCloseDateRequired': 'Please select registration close date.',
      'AlphaDashSpace': 'This field must only contain alpha-numeric characters, underscores, dashes and space.',
    };
  }

  ngOnInit() {
    this.initClubAddForm();

    // Update page header text
    var routeObj = { 'Slug': '', 'ClubProgramID': '', 'ClubProgramName': '', 'Status': '' };
    localStorage.setItem('routeObject', JSON.stringify(routeObj));
    this.pageHeaderName = '';
  }

  initClubAddForm() {
    this.clubAddForm = this.fb.group({
      program_name: ['', [Validators.required, Validators.pattern(this.alphaDashSpaceRegex)]],
      description: [''],
      registration_open_date: ['', Validators.required],
      registration_close_date: ['', Validators.required],
      activeInactive: [this.programStatusValue],
      isPublicProgram: ['1'],
      isArchive: [this.isArchive],
      allowParentToEditQuestion: [this.allowParentToEditQuestion]
    }, {
        validator: this.dateLessThan('registration_open_date', 'registration_close_date')
      });
  }

  removeWhiteSpace(f) {
    const value = f.value;
    if (value.program_name === null || value.program_name === '') {
      return false;
    }
  }

  removeWhiteSpaceDescription(f) {
    const value = f.value;
    if (value.description === null || value.description === '') {
      return false;
    }
  }

  dateLessThan(registration_open_date: string, registration_close_date: string) {
    return (group: FormGroup): { [key: string]: any } => {
      const o = group.controls[registration_open_date];
      const c = group.controls[registration_close_date];
      if (o.value > c.value) {
        return {
          regRangeDates: '"To Date" cannot be before "The From Date"'
        };
      }
    };
  }

  onSave(event, clubAddForm) {
    console.log('ClubId - ', Number(localStorage.getItem('clubId')));
    
    if (clubAddForm.status === 'VALID') {
      this.isSaving = true;
      const value = clubAddForm.value;
      const obj = {
        ClubprogramTypeID: 2,
        ClubID: Number(localStorage.getItem('clubId')),
        Name: value.program_name,
        Description: value.description,
        Regstartdate: value.registration_open_date,
        Regenddate: value.registration_close_date,
        AddedBy: StorageUtil.userID,
        Regstatus: 1,
        Programstatus: value.activeInactive,
        Public: value.isPublicProgram,
        AllowParentToEditQuestion: value.allowParentToEditQuestion || 0
      };
      event.target.innerHTML = 'Saving <i class="fa fa-spinner fa-spin push-5-r"></i>';
      event.target.disabled = true;
      this.programService.createProgram(obj).subscribe(data => {
        event.target.innerHTML = '<i class="fa fa-plus push-5-r"></i> Add Program';
        event.target.disabled = false;
        const toast = this.notificationsService.success('success', 'Program successfully created.', {
          timeOut: 3000,
          showProgressBar: true,
          pauseOnHover: false,
          clickToClose: false
        });
        if (value.activeInactive === '0') {
          this.router.navigate(['tryoutprogram/inactive']);
        } else if (value.activeInactive === '1') {
          this.router.navigate(['tryoutprogram/active']);
        } else if (value.activeInactive === '2') {
          this.router.navigate(['tryoutprogram/archive']);
        }
      });
    } else {
      this.validateUi();
      this.isSaving = false;
    }
  }

  validateUi() {
    Object.keys(this.clubAddForm.controls).forEach(field => {
      const control = this.clubAddForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  isValidProgramName() {
    return this.clubAddForm.get('program_name').errors
      && (this.clubAddForm.get('program_name').touched
        || this.clubAddForm.get('program_name').dirty);
  }
  isValidDescription() {
    return this.clubAddForm.get('description').errors
      && (this.clubAddForm.get('description').touched
        || this.clubAddForm.get('description').dirty);
  }
  isValidRegistrationOpenDate() {
    return this.clubAddForm.get('registration_open_date').errors
      && (this.clubAddForm.get('registration_open_date').touched
        || this.clubAddForm.get('registration_open_date').dirty);
  }
  isValidRegistrationCloseDate() {
    return this.clubAddForm.get('registration_close_date').errors
      && (this.clubAddForm.get('registration_close_date').touched
        || this.clubAddForm.get('registration_close_date').dirty);
  }
}



// WEBPACK FOOTER //
// ./src/app/tryout/pages/tryout-programs/tryout-program-create/tryout-program-create.component.ts